import "./init";
import $i18n from "./i18n";
export { getPackI18n, getPackLocale } from "./pack";
export { I18n, init } from "./i18n";
export default $i18n;